// **********************************************************
// Portfolio Module
// **********************************************************

const portfolioSlider = document.querySelectorAll('[data-slider="portfolio-slider"]');

if (portfolioSlider.length > 0) {
  const portfolioSliderOptions = {
    slidesPerView: 'auto',
    slidesOffsetAfter: 80,
    spaceBetween: 8,
    speed: 400,
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 18,
        slidesOffsetAfter: 0,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 18,
        slidesOffsetAfter: 0,
      },
    },
  };

  const initSwiper = (el) => {
    if (windowWidth() <= breakpointSm) {
      el.swiperInstance?.destroy(true, true);
      el.swiperInstance = null;
      return;
    }
    el.swiperInstance?.destroy(true, true);
    el.swiperInstance = new Swiper(el, portfolioSliderOptions);
  };

  if (portfolioSlider) {
    portfolioSlider.forEach((el) => {
      const sliderEle = el.closest('.portfolio-module__slider');
      const brandSliderCard = sliderEle.querySelector('.brands-slider-card-slide');
      initSwiper(el);

      if (brandSliderCard) {
        el.swiperInstance?.appendSlide(brandSliderCard);
      }

      attachEvent('.portfolio-module__tab', 'click', (tab) => {
        const parentEle = tab.target.closest('.portfolio-module__tab');
        const groupEle = tab.target.closest('.portfolio-module__tabs-group');
        groupEle.querySelectorAll('.portfolio-module__tab').forEach((el) => el.classList.remove('is-active'));
        parentEle.classList.add('is-active');
      });
    });
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => portfolioSlider.forEach(initSwiper), 150);
  });

  const getActiveIds = (section, selector) =>
    [...section.querySelectorAll(selector)]
      .map((el) => el.dataset.categoryId || el.dataset.brandId || el.dataset.regionId)
      .join('|');

  const updateWrapper = (section, selector, html) => {
    const wrapper = section.querySelector(selector);
    if (wrapper && html !== undefined) {
      wrapper.innerHTML = html;
    }
  };

  const axiosGetNewProducts = async (ev) => {
    const section = ev.target.closest('section');
    const clickedCategories = !!ev.target.closest('button[data-category-id]');
    const clickedBrands = !!ev.target.closest('button[data-brand-id]');
    const clickedRegions = !!ev.target.closest('button[data-region-id]');

    if (clickedRegions) {
      section
        .querySelectorAll('.is-active[data-category-id], .is-active[data-brand-id]')
        .forEach((el) => el.classList.remove('is-active'));
    }
    if (clickedCategories) {
      section.querySelectorAll('.is-active[data-brand-id]').forEach((el) => el.classList.remove('is-active'));
    }

    const availableCategories = section.querySelector('[data-available-categories]')?.dataset.availableCategories || '';

    const formDataInput = {
      action: 'getNewProducts',
      selected_brands: getActiveIds(section, '.is-active[data-brand-id]'),
      selected_categories: getActiveIds(section, '.is-active[data-category-id]'),
      selected_regions: getActiveIds(section, '.is-active[data-region-id]'),
      clicked_categories: clickedCategories,
      available_categories: availableCategories,
    };

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);

      updateWrapper(section, '.portfolio-module .swiper-wrapper', data.data.html);
      section.querySelector('.portfolio-module__slider')?.scrollTo(0, 0);

      if (!clickedBrands) {
        if (data.data.html_brands) {
          updateWrapper(
            section,
            '.portfolio-module .brands-logos .portfolio-module__tabs-group-inner',
            data.data.html_brands,
          );
        } else if (clickedCategories) {
          updateWrapper(section, '.portfolio-module .brands-logos .portfolio-module__tabs-group-inner', '');
        }
      }

      updateWrapper(section, '.portfolio-module .regions .portfolio-module__tabs-group-inner', data.data.html_regions);

      if (!clickedBrands) {
        updateWrapper(
          section,
          '.portfolio-module [data-available-categories] .portfolio-module__tabs-group-inner',
          data.data.html_categories,
        );
      }

      section
        .querySelectorAll('[data-slider="portfolio-slider"], [data-slider="brands-slider-card"]')
        .forEach(initSwiper);
    } catch (err) {
      console.error('Failed to fetch new products:', err);
    }
  };

  attachEvent('.portfolio-module__tabs .portfolio-module__tab', 'click', async (ele) => {
    await axiosGetNewProducts(ele);
  });

  // Logo slider

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const anim = entry.target._gsapAnim;
        if (!anim) return;
        if (entry.isIntersecting) {
          anim.play();
        } else {
          anim.pause();
        }
      });
    },
    { threshold: 0.1 },
  );

  document.querySelectorAll('.portfolio-module__logos').forEach((slider) => {
    const track = slider.querySelector('.portfolio-module__logos-track');
    const row = slider.querySelector('.portfolio-module__logos-row');
    if (!track || !row) return;

    track.appendChild(row.cloneNode(true));

    const rowWidth = row.getBoundingClientRect().width;

    const anim = gsap.to(track, {
      x: `-${rowWidth}px`,
      duration: 40,
      ease: 'linear',
      repeat: -1,
      modifiers: {
        x: gsap.utils.unitize((x) => parseFloat(x) % rowWidth),
      },
    });

    slider._gsapAnim = anim;
    observer.observe(slider);
  });
}
